// src/layout/AppShell.jsx
import React from "react";
import { Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

export default function AppShell({ title, children }) {
  const location = useLocation();

  // ⭐ If printing, bypass ALL layout wrappers
  if (location.pathname.startsWith("/print")) {
    console.log("[APPSHELL] Bypassing layout for /print");
    return <>{children}</>;
  }

  return (
    <Box
      bg="white"
      minH="100vh"
      display="flex"
      flexDirection="column"
      overflowX="hidden"
    >
      {/* ⭐ Page Content */}
      <Box flex="1" pt="0">
        {children}
      </Box>
    </Box>
  );
}
